package i18n

import com.soywiz.korio.file.std.*
import com.soywiz.korio.lang.*
import kotlin.jvm.*

object Localization {
    const val DEFAULT_LOCALE = "en"

    var CURRENT_LOCALE: String = DEFAULT_LOCALE

    private val filePath: String
        get() = "i18n/strings_$CURRENT_LOCALE.properties"

    val strings: LStrings
        get() = internalStrings ?: throw IllegalStateException("")

    @Volatile
    private var internalStrings: LStrings? = null

    suspend fun loadResources() {
        val resourceFile = resourcesVfs[filePath].takeIfExists()
            ?: run {
                CURRENT_LOCALE = DEFAULT_LOCALE
                resourcesVfs[filePath]
            }

        internalStrings = LStrings(resourceFile.readProperties())
    }
}

class LStrings internal constructor(properties: Properties) {
    val scene = LScene(properties)
}

class LScene internal constructor(properties: Properties) {
    val main = LSceneMain(properties)
    val lobby = LSceneLobby(properties)
    val loading = LSceneLoading(properties)
    val baseLevel = LSceneBaseLevel(properties)
}

class LSceneMain internal constructor(properties: Properties) {
    val startButton = properties["scene.main.start_button"].orEmpty()
}

class LSceneLobby internal constructor(properties: Properties) {
    val playButton = properties["scene.lobby.play_button"].orEmpty()
    val selectedLevel = properties["scene.lobby.selected_level"].orEmpty()
    val controlsTitle = properties["scene.lobby.controls_title"].orEmpty()
    // desktop
    val controlLeftDesktop = properties["scene.lobby.control_left"].orEmpty()
    val controlRightDesktop = properties["scene.lobby.control_right"].orEmpty()
    val controlJumpDesktop = properties["scene.lobby.control_jump"].orEmpty()
    val controlDashDesktop = properties["scene.lobby.control_dash"].orEmpty()
    // touch
    val controlsTouch = properties["scene.lobby.control_touch"].orEmpty()

    val back = properties["scene.lobby.back"].orEmpty()
}

class LSceneLoading internal constructor(properties: Properties) {
    val loading = properties["scene.loading.loading"].orEmpty()
    val level = properties["scene.loading.level"].orEmpty()
}

class LSceneBaseLevel internal constructor(properties: Properties) {
    val menu = properties["scene.baselevel.menu"].orEmpty()
    val menuResume = properties["scene.baselevel.menuResume"].orEmpty()
    val menuExit = properties["scene.baselevel.menuExit"].orEmpty()
    val victory = properties["scene.baselevel.victory"].orEmpty()
    val menuContinue = properties["scene.baselevel.menuContinue"].orEmpty()
}
